import { createReducer, on } from '@ngrx/store';
import * as MemberFormActions from '../actions/member-form.action';
import { MemberForm } from '../../models';

export interface MemberFormState {
  memberForm: MemberForm | null;
  saving: boolean;
  saved: boolean;
  submitted: boolean;
  saveError?: any;
}

export const initialState: MemberFormState = {
  memberForm: null,
  saved: false,
  saving: false,
  submitted: false,
};

export const MemberFormReducer = createReducer(
  initialState,
  on(MemberFormActions.SubmitMemberForm, (state: MemberFormState) => {
    return {
      ...state,
      saved: false,
      saving: true,
      saveError: null,
      submitted: true,
    };
  }),

  on(MemberFormActions.ResetMemberForm, (state: MemberFormState) => {
    return {
      ...initialState,
    };
  }),

  on(MemberFormActions.SubmitMemberFormSuccess, (state: MemberFormState, { memberForm }) => {
    return {
      ...state,
      memberForm,
      saving: false,
      saved: true,
      submitted: true,
    };
  }),

  on(MemberFormActions.SubmitMemberFormFail, (state: MemberFormState, { error }) => {
    return {
      ...state,
      saving: false,
      saved: false,
      saveError: error,
      submitted: true,
    };
  })
);

export const getMemberForm = (state: MemberFormState) => state.memberForm;
export const getMemberFormSaved = (state: MemberFormState) => state.saved;
export const getMemberFormSaving = (state: MemberFormState) => state.saving;
export const getMemberFormSaveError = (state: MemberFormState) => state.saveError;
export const getMemberFormSubmitted = (state: MemberFormState) => state.submitted;
